import React from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
} from "@mui/material";
export const DeleteDialog = ({ open, onClose, onConfirm, hasChildren }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">
        {hasChildren ? "Cannot Delete Activity" : "Confirm Node Deletion"}
      </DialogTitle>
      {hasChildren && (
        <DialogContent>
          Please delete all sub-activities first.
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose}>{hasChildren ? "OK" : "Cancel"}</Button>
        {!hasChildren && (
          <Button onClick={onConfirm} color="error">
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
